import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';
import { TestPlanSummaryTable } from '../components/TestPlanSummaryTable';
import { Form } from '@ant-design/compatible';
import './ReviewPage.scss';

export class ReviewPage extends React.Component {
    static propTypes = {
        wizard: PropTypes.object,
        updateWizardData: PropTypes.func,
        location: PropTypes.object,
        saveTestPlan: PropTypes.func
    };

    render() {
        return (
            <div className="page review-page">
                <div className="section">
                    <TestPlanSummaryTable requiredEquipment={this.props.wizard.requiredEquipment} wizard={this.props.wizard} />
                </div>
                <div className="section">
                    <div className="title">Test Plan Name:</div>
                    <Form.Item
                        validateStatus={this.props.wizard.validation.fields.name ? '' : 'error'}
                        help={this.props.wizard.validation.fields.name ? '' : 'Must not be empty'}
                    >
                        <Input
                            onChange={(e) => this.props.updateWizardData({ name: e.target.value })}
                            defaultValue={this.props.wizard.name}
                            className='w-400'
                        />
                    </Form.Item>
                </div>

                <Button
                    onClick={() => {
                        let alertMessages = [];

                        if (!this.props.wizard.validation.fields.cablesPerAssembly) {
                            alertMessages.push(
                                'A valid number greater than 1 must be entered for the "Cables per Assembly" field on the DUT Config page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.fibersPerCable) {
                            alertMessages.push(
                                'A valid number greater than 1 must be entered for the "Fibers per Cable" field on the DUT Config page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.terminationTypeEndA) {
                            alertMessages.push(
                                'A valid termination type must be selected for End A on the DUT Config page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.terminationTypeEndB) {
                            alertMessages.push(
                                'A valid termination type must be selected for End B on the DUT Config page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.tests) {
                            alertMessages.push('One or more tests must be selected on the Setup page.');
                        }

                        if (!this.props.wizard.validation.fields.wavelengths) {
                            alertMessages.push('One or more wavelengths must be selected on the IL/RL page.');
                        }

                        if (!this.props.wizard.validation.fields.ilCompValid) {
                            alertMessages.push(
                                'IL compensation fiber attenuation values must be entered for all selected wavelengths on the IL/RL page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.riValid) {
                            alertMessages.push(
                                'Valid IL and/or RL specifications must be entered for all fibers in the Fiber Specifications on the IL/RL page.'
                            );
                        }

                        if (this.props.wizard.validation.fields.switch0.some((isValid) => !isValid)) {
                            alertMessages.push(
                                'Valid output channels must be entered for all fibers in the Fiber Mapping on the IL/RL page.'
                            );
                        }

                        if (this.props.wizard.validation.fields.switch1.some((isValid) => !isValid)) {
                            alertMessages.push(
                                'Valid switch 1 channels must be entered for all fibers in the Fiber Mapping on the IL/RL page.'
                            );
                        }

                        if (this.props.wizard.validation.fields.switch2.some((isValid) => !isValid)) {
                            alertMessages.push(
                                'Valid switch 2 channels must be entered for all fibers in the Fiber Mapping on the IL/RL page.'
                            );
                        }

                        if (this.props.wizard.validation.fields.tj1Length.some((isValid) => !isValid)) {
                            alertMessages.push(
                                'Valid TJ1 lengths must be entered for all fibers in the Fiber Mapping on the IL/RL page.'
                            );
                        }

                        if (this.props.wizard.validation.fields.tj2Length.some((isValid) => !isValid)) {
                            alertMessages.push(
                                'Valid TJ2 lengths must be entered for all fibers in the Fiber Mapping on the IL/RL page.'
                            );
                        }

                        if (!this.props.wizard.validation.fields.customField) {
                            alertMessages.push(
                                'Custom fields must be selected for all custom field entries on the Label page.'
                            );
                        }

                        if (!/\S/.test(this.props.wizard.name)) {
                            alertMessages.push('A name must be entered for the Test Plan.');
                        }

                        if (alertMessages.length > 0) {
                            alert(alertMessages.join('\n\n'));
                        } else {
                            this.props.saveTestPlan();
                        }
                    }}
                    type={
                        !this.props.wizard.validation.wizard ||
                        (!this.props.wizard.assembly.insertionLossSideA &&
                            !this.props.wizard.assembly.insertionLossSideB &&
                            !this.props.wizard.assembly.returnLossSideA &&
                            !this.props.wizard.assembly.insertionLossTotal &&
                            !this.props.wizard.assembly.returnLossSideB &&
                            !this.props.wizard.assembly.returnLossTotal &&
                            !this.props.wizard.assembly.testPolarity)
                            ? 'danger'
                            : 'primary'
                    }
                    block
                    shape="round"
                >
                    {this.props.location.pathname.includes('/new/') ? 'Create Test Plan' : 'Update Test Plan'}
                </Button>
            </div>
        );
    }
}